import React, { createContext, useContext, useEffect, useState } from "react";
import { api, currentUser, setAuth, clearAuth } from "./api";

const AuthCtx = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(currentUser());

  useEffect(() => {
    const token = localStorage.getItem("cm_token");
    if (token && !user) {
      api.get("/auth/me").then((r) => setUser(r.data)).catch(() => {});
    }
  }, []); // eslint-disable-line

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    setAuth(data.token, data.user);
    setUser(data.user);
    return data.user;
  };

  const registerPatient = async (payload) => {
    const { data } = await api.post("/auth/register/patient", payload);
    setAuth(data.token, data.user);
    setUser(data.user);
    return data.user;
  };

  const registerDoctor = async (payload) => {
    const { data } = await api.post("/auth/register/doctor", payload);
    setAuth(data.token, data.user);
    setUser(data.user);
    return data.user;
  };

  const logout = () => {
    clearAuth();
    setUser(null);
  };

  return (
    <AuthCtx.Provider value={{ user, login, logout, registerPatient, registerDoctor, setUser }}>
      {children}
    </AuthCtx.Provider>
  );
};

export const useAuth = () => useContext(AuthCtx);
